<emm-management-layout>
    <main class="layout-center-content content" layout-center-content>
        <mat-button-toggle
            [disabled]="cleared | async"
            [attr.data-testid]="'clear_cache_button'"
            matTooltip="Clear cache"
            (click)="clearCache()"
        >
            Clear Cache <img class="icon" src="assets/img/bulldozer.svg"/>
        </mat-button-toggle>

        <mat-button-toggle
            [attr.data-testid]="'copy_database_button'"
            matTooltip="Copy data from the EMM prod database"
            (click)="handleCopyProdDataClicked()"
            [disabled]="dataCopied | async"
            *ngIf="!isProd && isAdminOrSuperAdmin"
        >
            Copy Prod Data <img class="icon" src="assets/img/nametags.svg"/>
        </mat-button-toggle>
    </main>
</emm-management-layout>
